<div class="card shadow-sm mb-3" [wlAutomationId]="automationId">
  <div class="card-body">
    @if (title) {
      <h3 *scText="title"></h3>
    }
    <p *wlGenericRichText="body" class="mb-0"></p>
    <ng-content></ng-content>
  </div>
</div>
